import jwt_decode from "jwt-decode";

function Reducer(state, action) {
    if (Array.isArray(action)) {
        action.forEach((x) => {
            state = Reducer(state, x);
        });
        return state;
    }
    else {
        switch (action.type) {
            case 'SET_LOGGED':
                let isLogged = false;
                let jwt = null;
                let refrestoken = null;
                let newProfile = state.profile;

                // Set the user data...
                if (action.payload != null) {
                    isLogged = true;
                    jwt = action.payload.token;
                    refrestoken = action.payload.refrestoken;
                    localStorage.setItem("auth", JSON.stringify(action.payload));
                }
                else {
                    newProfile = null;
                    localStorage.removeItem("auth");
                }

                return {
                    ...state,
                    profile: newProfile,
                    isLogged: isLogged,
                    jwt: jwt,
                    refrestoken: refrestoken
                };
            case 'SET_LOADING':
                if (action.payload != state.loading)
                    return { ...state, loading: action.payload };
                else
                    return state;
            case 'SET_PROFILE':
                return { ...state, profile: action.payload };
            case 'SET_TOAST':
                return { ...state, toast: action.payload };
            case 'ADD_TOAST':
                return { ...state, toast: [...state.toast, action.payload] };
            case 'SET_READY':
                return { ...state, ready: action.payload };
            case 'SET_CONFIG':
                return { ...state, config: action.payload };
            case 'SET_NEW_CHATLIST':
                return { ...state, newlist: action.payload?.newList, currentChatId: action.payload?.currentChatId };
            case 'SET_RELOAD_CHATLIST':
                return { ...state, reloadchatlist: action.payload };
            case 'SET_HOOTSUITETOKEN':
                return { ...state, hootSuiteToken: action.payload };
            case 'SET_HUB':
                if (state.hubConnection) {
                    state.hubConnection.stop()
                }
                return { ...state, hubConnection: action.payload };
            default:
                return state;
        }
    }
};

export default Reducer;